import React, {useEffect, useState} from 'react';
import {Carousel} from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {CSSTransition} from "react-transition-group";
import {useSelector} from "react-redux";

import styles from './ShopOffers.module.scss';
import CategoryTitleImg from "../../assets/images/category_background.png";

import OffersLayoutsManager from "../../components/offers/offersLayouts/OffersLayoutsManager";
import {NO_CAROUSEL_LAYOUT,
        HAS_SEARCH_BAR,
        HAS_CATEGORY_NAVIGATION,
        API} from "../../shared/constants";
import SearchBar from "../../components/SearchBar/SearchBar";
import FilterNavigationMobile from "../../components/Filter/FilterNavigationMobile";
import FilterNavigation from '../../components/Filter/FilterNavigation';
import BannerWithLinkForCarousel from "../../components/BannerWithLinkForCarousel/BannerWithLinkForCarousel";
import { openUrlInNewTab } from '../../shared/helpers';

const PromoBanner = API.url + 'banner/shop?v=' + Date.now();
const PromoBannerMobile = API.url + 'banner/shopMobile?v=' + Date.now();

const renderOffersInCarousel = (category, selectOfferById, openPopupInfo, config) => {
    const offersWithTimers = category.packs.filter(cat => cat.endTime);
    const offersWithQuantity = category.packs.filter(cat => cat.leftPurchases && cat.leftPurchases > 0);

    return (
        <div className={styles.itemOffersWrapper}>
            <div className={styles.itemOffersTitle}>
                <img className={styles.categoryTitleImg} src={CategoryTitleImg} alt={''} />
                <div className={styles.categoryTitleName}>{category.name}</div>
            </div>
            <Carousel
                autoPlay={true}
                infiniteLoop={true}
                interval={5000}
                showArrows={false}
                showStatus={false}
                stopOnHover={true}
                showThumbs={false}
                showIndicators={category.packs.length > 1}
            >
                {category.packs.length ?
                    category.packs.map((offer, index) => (
                        <OffersLayoutsManager
                            offer={offer}
                            categoryId={category.order}
                            key={index}
                            selectOfferById={selectOfferById}
                            openPopupInfo={openPopupInfo}
                            noTimers={!offersWithTimers.length}
                            noQuantityCap={!offersWithQuantity.length}
                        />
                    ))
                    :
                    <div className={styles.noProducts}>{config.noProducts}</div>
                }
            </Carousel>
        </div>
    );
};
const renderOffersNormal = (category, selectOfferById, openPopupInfo, config, isMobileView) => {
    const offersWithTimers = category.packs.filter(cat => cat.endTime);
    const offersWithQuantity = category.packs.filter(cat => cat.leftPurchases && cat.leftPurchases > 0);

    return (
        <div className={styles.itemOffersWrapper}>
            <div id={category.order}></div>
            <CSSTransition in appear timeout={300} classNames={'fade-in-slide-down'}>
                <div className={styles.itemOffersTitle}>
                    {/* <img className={styles.categoryTitleImg} src={isMobileView ? category.bannerSmall : category.bannerBig} alt={category.name} /> */}
                    <img className={`${category.categoryIcon ? styles.categoryImg : styles.defaultIcon}`} src={category.categoryIcon} alt={''} />
                    <div className={styles.categoryName}>{category.name}</div>
                </div>
            </CSSTransition>
            <div className={styles.itemOfferPackage}>
                {category.packs.length ?
                    category.packs.map((offer, index) => (
                        <OffersLayoutsManager
                            offer={offer}
                            categoryId={category.order}
                            key={index}
                            selectOfferById={selectOfferById}
                            openPopupInfo={openPopupInfo}
                            noTimers={!offersWithTimers.length}
                            noQuantityCap={!offersWithQuantity.length}
                        />
                    ))
                    :
                    <div className={styles.noProducts}>{config.noProducts}</div>
                }
            </div>
        </div>
    );
};

const ShopOffers = ({
    selectOfferById,
    config,
    windowSize,
    offersCategories,
    filterCategory,
    openOfferPopupInfo,
    allOffers,
    filterOffers,
    resetOffersFilter,
    searchedOffers,
    hasActiveSearch,
    highlightedOffers,
    promoBannerUrl
}) => {
    const { isLoading } = useSelector(state => state.rootReducer);
    const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
    let selectedCategories = [];
    if (windowSize.isMobileView) {
        selectedCategories = offersCategories.filter(category => !category.isHidden);
    }

    // show the searched offers if any
    let offersToShow = allOffers;
    if (searchedOffers.length || hasActiveSearch) {
        offersToShow = searchedOffers;
    } else {
        offersToShow = allOffers;
    }

    useEffect(() => {
        const { hash } = window.location;

        if (hash && hash.length) {
            const elementToScroll = document.getElementById(hash?.replace("#", ""));
            elementToScroll.scrollIntoView({behavior: "smooth"});
        }
    }, []);

    return (
        <div className={styles.allOffersWrapper}>
            {windowSize.isMobileView && offersCategories.length ?
                isMobileFilterOpen ?
                    <div id={'opened'} className={styles.filterBarWrapper} onClick={() => setIsMobileFilterOpen(false)}>
                        <div className={styles.filterIconWrapper}>
                            <div className={styles.filterIconPart}></div>
                            <div className={styles.filterIconPart}></div>
                            <div className={styles.filterIconPart}></div>
                        </div>
                        <div className={styles.text}>{config.filterClose}</div>
                    </div>
                    :
                    <div id={'closed'} className={styles.filterBarWrapper} onClick={() => setIsMobileFilterOpen(true)}>
                        <div className={styles.filterIconWrapper}>
                            <div className={styles.filterIconPart}></div>
                            <div className={styles.filterIconPart}></div>
                            <div className={styles.filterIconPart}></div>
                        </div>
                        <div className={styles.text}>{config.filter}</div>
                    </div>
                :
                null
            }
             <CSSTransition
                in={windowSize.isMobileView && HAS_CATEGORY_NAVIGATION && isMobileFilterOpen}
                timeout={400}
                classNames="fade-in-slide-down"
                unmountOnExit
            >
                <FilterNavigationMobile
                    offersCategories={offersCategories}
                    isOpen={isMobileFilterOpen}
                    setIsOpen={setIsMobileFilterOpen}
                />  
            </CSSTransition>
            <CSSTransition
                in={!isMobileFilterOpen}
                timeout={400}
                classNames="fade"
                unmountOnExit
            >
                <div className={styles.offersWrapperSide}>
                    <div className={styles.navigationAndSearchWrapper}>
                        {!windowSize.isMobileView ?
                            <FilterNavigation
                                config={config}
                                offersCategories={offersCategories}
                                filterCategory={filterCategory}
                            />
                            :
                            null
                        }
                        {HAS_SEARCH_BAR ?
                            <SearchBar config={config} filterOffers={filterOffers}
                                       resetOffersFilter={resetOffersFilter}/>
                            : null
                        }
                    </div>
                    <img
                        className={`${styles.promoBanner} ${promoBannerUrl ? 'clickable' : ''}`}
                        src={windowSize.isMobileView ? PromoBannerMobile : PromoBanner}
                        alt={''}
                        onClick={() => openUrlInNewTab(promoBannerUrl)}
                    />
                    {highlightedOffers && highlightedOffers.length > 0 ?
                        <div className={styles.highlitedOffersWrapper}>
                            <Carousel
                                autoPlay={true}
                                infiniteLoop={true}
                                interval={5000}
                                showArrows={true}
                                showStatus={false}
                                stopOnHover={true}
                                showThumbs={false}
                                showIndicators={highlightedOffers.length > 1}
                            >
                                {highlightedOffers.map((offer, index) => {
                                    const component = offer.noOffer ?
                                        <BannerWithLinkForCarousel key={index} {...offer} />
                                        :
                                        <OffersLayoutsManager
                                            offer={offer}
                                            isBannerLayout={true}
                                            key={index}
                                            selectOfferById={selectOfferById}
                                            openPopupInfo={openOfferPopupInfo}
                                            noTimers={!highlightedOffers.filter(cat => cat.endTime).length}
                                        />

                                    return component;
                                })}
                            </Carousel>
                        </div>
                        :
                        null
                    }
                    {offersToShow.length ?
                        offersToShow.map((category, index) => {
                            const noCarouselCategory = category.packs.filter(pac => pac.layout === NO_CAROUSEL_LAYOUT);
                            return (
                                <CSSTransition
                                    key={index}
                                    in={!category.isHidden}
                                    timeout={400}
                                    classNames="fade"
                                    unmountOnExit
                                >
                                    {windowSize.isMobileView && !noCarouselCategory.length ?
                                        renderOffersNormal(category, selectOfferById, openOfferPopupInfo, config, true)
                                        :
                                        renderOffersNormal(category, selectOfferById, openOfferPopupInfo, config)
                                    }
                                </CSSTransition>
                            )
                        })
                        :
                        !isLoading ?
                            <div className={styles.noProductsGeneral}>{config.noProducts}</div>
                            :
                            null
                    }
                </div>
            </CSSTransition>
        </div>
    );
};

export default ShopOffers;